import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M3 18v-2h18v2Zm0-5v-2h18v2Zm0-5V6h18v2Z" />
    </svg>
  )
}

type MenuIconProps = SvgIconProps

export const MenuIcon: React.FC<MenuIconProps> = (props) => {
  return (
    <SvgIcon {...props} className="w-8 h-8 md:w-7 md:h-7" viewBox="0 0 24 24" focusable="false" aria-hidden="true" />
  )
}
